import { DefaultItem } from '@adsk/alloy-react-dropdown';
import { report } from '@adsk/exo-skeleton-api';

export type ItemWithImage = DefaultItem & {
  imageUrl?: string;
};

export const IconSize = 24;

export const PROJECT_TYPES_DATA: DefaultItem[] = [
  {
    value: 'bim360',
    label: 'BIM360',
  },
  {
    value: 'acc',
    label: 'ACC',
  },
];

export const isValidFilter = (filterKey: string, filterValue: string) => {
  if (filterKey === 'created_on') {
    const [from, to] = filterValue.split('..');
    const fromDate = new Date(from);
    const toDate = new Date(to);
    if (
      (from && fromDate.toString() === 'Invalid Date') ||
      (to && toDate.toString() === 'Invalid Date')
    ) {
      report({
        scope: 'accProjectList',
        type: 'warning',
        value:
          '[ProjectList] - Invalid Date was sent in created_on filter via url',
        context: {
          from,
          to,
          scope: 'accProjectList',
        },
      });
      return false;
    }
  }

  return true;
};
